import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/resources/$id/versions/new/general")({
  staticData: {
    title: "common.general",
  },
});
